export default __webpack_public_path__ + "static/media/blue_plus_add_promo_code.83dc8f6e.svg";